import styles from '@components/components/Modal/SignUpPlanModal/SignUpPlanModal.module.scss';
import MeinWienenergieLogo from '@components/images/logo-mein-wienenergie.inline.svg';
import { useTracking } from '@components/hooks';
import React, { useState, useEffect } from 'react';
import { Button, Heading, Link, Modal } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const SignUpMultiplePlanModal = ({
  newCustomerUrls,
  existingCustomerUrl,
  id,
  title,
  dialog,
  trackEvent,
}) => {
  const open = dialog.useState('open');
  const track = useTracking();
  const STEPS = {
    STEP_1: 'step-1',
    MULTIPLE: 'multiple',
  };
  const [step, setStep] = useState(STEPS.STEP_1);
  const trackClick = interaction => {
    track({
      event: trackEvent ?? 'signupModalEvent',
      interaction,
      tarifId: id,
      tarifName: title,
    });
  };

  useEffect(() => {
    if (open) {
      return;
    }
    let url = null;

    if (existingCustomerUrl) {
      url = STEPS.STEP_1;
    } else {
      url = STEPS.MULTIPLE;
    }

    setStep(url);
  }, [open]);
  const stepNewOrExisting = (
    <div className={styles.contentContainer}>
      <Heading noSpacing size="h5">
        Sind Sie bereits Kund*in?
      </Heading>
      <Heading as="h6" className={styles.answerHeading} noSpacing size="h7">
        Nein
      </Heading>
      <p className={styles.section}>
        In wenigen Schritten zu Ihrem neuen Tarif
      </p>
      <Button
        className={styles.modalButton}
        isElevated
        onClick={() => {
          trackClick('click-kunde-werden');
          setStep(STEPS.MULTIPLE);
        }}
      >
        Kund*in werden & Tarif anmelden
      </Button>
      <Heading as="h6" className={styles.answerHeading} noSpacing size="h7">
        Ja
      </Heading>
      <p className={styles.section}>
        Wechseln Sie Ihren Tarif einfach im Service Bereich
      </p>
      <Button
        className={styles.modalButton}
        isElevated
        onClick={() => {
          trackClick('click-tarif-wechseln');
        }}
        render={<Link to={existingCustomerUrl} />}
        theme="tertiary"
      >
        Einloggen & Tarif wechseln
      </Button>
    </div>
  );

  const stepMultiple = (
    <>
      <Heading align="center" noSpacing size="h5">
        Vertragsdauer
      </Heading>
      <p className={styles.section}>
        Welche Mindestvertragsdauer bevorzugen Sie?
      </p>
      <div className={classNames(styles.contentContainer, styles.step2)}>
        <div className={styles.modalButtonContainer}>
          {newCustomerUrls.map(entry => (
            <Button
              className={classNames(styles.modalButton, styles.step2)}
              isElevated
              key={entry.link}
              render={<Link to={entry.link} />}
            >
              {entry.label}
            </Button>
          ))}
        </div>
      </div>
    </>
  );

  return (
    <Modal
      header={<MeinWienenergieLogo height="14px" />}
      store={dialog}
      theme="secondary"
    >
      {step === STEPS.STEP_1 && stepNewOrExisting}
      {step === STEPS.MULTIPLE && stepMultiple}
    </Modal>
  );
};

export default SignUpMultiplePlanModal;
